export default {
  DOWNLOAD_CSV: 'downloadCsv',
};
